import { render, staticRenderFns } from "./modal-closable.vue?vue&type=template&id=4f162253&"
import script from "./modal-closable.vue?vue&type=script&lang=js&"
export * from "./modal-closable.vue?vue&type=script&lang=js&"
import style0 from "./modal-closable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports